
<div class="blur_cls">
	<div style="width:100%; height:100%; ">
		<div class="row">
			<div class="col-md-12">
					<div class="col-lg-4 mx-auto">
						<div class="login_main mt-5">
							<div class="row">
								<div class="col-md-12 text-center pt-3 pb-3">
									<img src="./xps/asset/img/berkley_logo.jpg">
								</div>
								<div class="col-md-12 text-center">
									<h4>Sign in with your W.R. Berkley account </h4>
								</div>
								<div class="col-lg-12 mt-2 mb-2">
									<input class="form-control box_border_sty" placeholder="someone@example.com">
								</div>
								<div class="col-md-12 d-block text-center">
									<a href="#" class="next_btn_cls">Next</a>
								</div>
								
								<div class="col-md-12 mt-3 mb-3">
									<a href="#">Sign in using an X.509 certificate</a>
								</div>
								
								<div class="col-md-12 mt-1 mb-4	 text-center">
									<a href="#">Forgot Password</a>
								</div>
								
								<div class="col-md-12 text-center">
									<p>By signing in you agree to be bound to the <a href="#">Terms of Use</a> and <a href="#">Privacy Policy</a> of W.R. Berkley Corporation and its subsidiaries.</p>
									<p>Need help? Please contact our Client Services team at <br/><a href="#">help&#64;wrberkley.com</a> or <a href="#">515-564-2300</a> </p>
								</div>						
							</div>
						</div>
					</div>			
			</div>
			<div class="col-md-12">
				<div class="footer_text">
					&copy; 2020 W.R. Berkley Corporation. All Rights Reserved
				</div>
			</div>
			
		</div>
		
		
		
	</div>
</div>


